/**
 * Hoergeraetebatterien Bestellassistent
 * Version 4.0 - Unterstuetzt mehrere Produkte und Varianten
 */

(function() {
  'use strict';

  function BatteryAssistant(sectionId) {
    this.sectionId = sectionId;
    this.container = document.getElementById('BatteryAssistant-' + sectionId);
    
    if (!this.container) {
      console.error('Battery Assistant: Container nicht gefunden fuer ID:', sectionId);
      return;
    }
    
    this.dataElement = document.getElementById('BatteryAssistantData-' + sectionId);
    if (!this.dataElement) {
      console.error('Battery Assistant: Daten-Element nicht gefunden fuer ID:', sectionId);
      return;
    }
    
    try {
      this.data = JSON.parse(this.dataElement.textContent);
      console.log('Battery Assistant: Daten geladen', this.data);
    } catch (e) {
      console.error('Battery Assistant: Fehler beim Parsen der Daten', e);
      return;
    }
    
    // Multi-Produkt Modus
    this.useMultipleProducts = this.data.useMultipleProducts || false;
    this.products = this.data.products || [];
    this.selectedProduct = null;
    this.skipVariantSteps = false;

    // Bestimme den ersten Schritt
    if (this.useMultipleProducts) {
      this.currentStep = this.data.showIntroStep ? 1 : 'product';
      this.totalSteps = this.data.showIntroStep ? 6 : 5;
    } else {
      this.currentStep = this.data.showIntroStep ? 1 : 2;
      this.totalSteps = this.data.showIntroStep ? 5 : 4;
    }
    
    this.selection = {
      productId: null,
      productTitle: null,
      sizeCode: null,
      sizeDisplay: null,
      sizeColor: null,
      brand: null,
      variantId: null,
      price: null,
      image: null,
      quantity: 1
    };
    
    this.isProcessing = false;
    this.init();
  }
  
  BatteryAssistant.prototype.init = function() {
    console.log('Battery Assistant: Initialisiere fuer Section', this.sectionId);
    console.log('Battery Assistant: Multi-Produkt Modus:', this.useMultipleProducts);
    console.log('Battery Assistant: Produkte:', this.products);
    
    this.updateProgress();
    this.showStep(this.currentStep);
    this.updateBackButtons();
    this.bindEvents();
    
    var self = this;
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(e) {
        if (e.detail.sectionId === self.sectionId) {
          self.restart();
        }
      });
    }
  };
  
  BatteryAssistant.prototype.bindEvents = function() {
    var self = this;
    
    this.container.addEventListener('click', function(e) {
      var target = e.target;
      var button = target.closest('button');
      
      if (!button) return;
      
      var action = button.dataset.action;
      
      if (action) {
        e.preventDefault();
        console.log('Battery Assistant: Aktion', action, button.dataset);
        
        switch(action) {
          case 'go-to-step':
            var step = button.dataset.step;
            // Kann 'product' oder eine Zahl sein
            if (step === 'product') {
              self.goToStep('product');
            } else {
              var stepNum = parseInt(step);
              if (stepNum) self.goToStep(stepNum);
            }
            break;
          case 'toggle-help':
            self.toggleHelp();
            break;
          case 'toggle-size-help':
            self.toggleSizeHelp();
            break;
          case 'select-product':
            var productId = button.dataset.productId;
            var blockId = button.dataset.blockId;
            var hasVariants = button.dataset.hasVariants === 'true';
            if (productId) self.selectProduct(productId, blockId, hasVariants, button);
            break;
          case 'select-size':
            var sizeCode = button.dataset.sizeCode;
            var size = button.dataset.size;
            var colorName = button.dataset.sizeColor;
            if (sizeCode) self.selectSize(sizeCode, size, colorName, button);
            break;
          case 'select-brand':
            var variantId = button.dataset.variantId;
            var brand = button.dataset.brand;
            var price = button.dataset.price;
            var image = button.dataset.image;
            if (variantId) self.selectBrand(variantId, brand, price, image, button);
            break;
          case 'select-quantity':
            var quantity = button.dataset.quantity;
            if (quantity) self.selectQuantity(quantity, button);
            break;
          case 'add-to-cart':
            self.addToCart(button);
            break;
          case 'restart':
            self.restart();
            break;
        }
      }
    });
  };
  
  BatteryAssistant.prototype.goToStep = function(step) {
    this.currentStep = step;
    this.showStep(step);
    this.updateProgress();
    this.updateBackButtons();
    
    // Step kann 'product' oder eine Zahl sein
    var stepId = (step === 'product') ? 'StepProduct' : 'Step' + step;
    var stepElement = document.getElementById(stepId + '-' + this.sectionId);
    if (stepElement) {
      var heading = stepElement.querySelector('.battery-assistant__heading');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus();
        stepElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };
  
  // Aktualisiere Zurücl-Buttons basierend auf dem aktuellen Pfad
  BatteryAssistant.prototype.updateBackButtons = function() {
    var self = this;
    var backButtons = this.container.querySelectorAll('.battery-assistant__btn--back');
    
    backButtons.forEach(function(btn) {
      var parentStep = btn.closest('.battery-assistant__step');
      if (parentStep) {
        var stepValue = parentStep.dataset.step;
        var stepNum = (stepValue === 'product') ? 'product' : parseInt(stepValue);
        var prevStep = self.getPreviousStep(stepNum);
        btn.dataset.step = prevStep;
      }
    });
  };
  
  BatteryAssistant.prototype.showStep = function(step) {
    var steps = this.container.querySelectorAll('.battery-assistant__step');
    for (var i = 0; i < steps.length; i++) {
      var s = steps[i];
      var stepValue = s.dataset.step;
      // Vergleiche als String, da 'product' auch moeglich ist
      var isMatch = (stepValue === String(step)) || (stepValue === step);
      if (isMatch) {
        s.hidden = false;
        s.classList.add('is-active');
      } else {
        s.hidden = true;
        s.classList.remove('is-active');
      }
    }
  };
  
  // Reihenfolge der tatsaechlich sichtbaren Schritte.
  // Enthaelt Zahlen und ggf. den String 'product', damit die Fortschrittsanzeige
  // ueber die Position rechnen kann statt ueber den Schrittwert selbst.
  BatteryAssistant.prototype.getStepSequence = function() {
    var sequence = [];
    if (this.data.showIntroStep) sequence.push(1);
    if (this.useMultipleProducts) sequence.push('product');
    if (!this.skipVariantSteps) {
      sequence.push(2);
      sequence.push(3);
    }
    sequence.push(4);
    sequence.push(5);
    return sequence;
  };

  BatteryAssistant.prototype.updateProgress = function() {
    var currentStepEl = document.getElementById('CurrentStep-' + this.sectionId);
    var totalStepsEl = document.getElementById('TotalSteps-' + this.sectionId);
    var progressFill = document.getElementById('ProgressFill-' + this.sectionId);

    var sequence = this.getStepSequence();
    var displayTotal = sequence.length;

    // this.currentStep kann 'product' sein. indexOf liefert deshalb die
    // Position, nicht der Schrittwert selbst - so entsteht nie NaN.
    var index = sequence.indexOf(this.currentStep);
    var displayStep = (index === -1) ? 1 : index + 1;

    this.totalSteps = displayTotal;

    if (currentStepEl) currentStepEl.textContent = displayStep;
    if (totalStepsEl) totalStepsEl.textContent = displayTotal;
    if (progressFill) {
      var percentage = Math.round((displayStep / displayTotal) * 100);
      progressFill.style.width = percentage + '%';
    }
  };
  
  BatteryAssistant.prototype.toggleHelp = function() {
    var helpSection = document.getElementById('HelpSection-' + this.sectionId);
    var button = this.container.querySelector('[data-action="toggle-help"]');
    
    if (helpSection) {
      var isHidden = helpSection.hidden;
      helpSection.hidden = !isHidden;
      helpSection.classList.toggle('is-open', isHidden);
      if (button) {
        button.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
      }
    }
  };
  
  BatteryAssistant.prototype.toggleSizeHelp = function() {
    var helpSection = document.getElementById('SizeHelp-' + this.sectionId);
    var button = this.container.querySelector('[data-action="toggle-size-help"]');
    
    if (helpSection) {
      var isHidden = helpSection.hidden;
      helpSection.hidden = !isHidden;
      helpSection.classList.toggle('is-open', isHidden);
      if (button) {
        button.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
      }
    }
  };
  
  // Neue Funktion: Produkt auswaehlen (Multi-Produkt Modus)
  BatteryAssistant.prototype.selectProduct = function(productId, blockId, hasVariants, element) {
    var cards = this.container.querySelectorAll('.battery-assistant__card--product');
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.remove('is-selected');
      cards[i].setAttribute('aria-checked', 'false');
    }
    
    element.classList.add('is-selected');
    element.setAttribute('aria-checked', 'true');
    
    // Finde das ausgewaehlte Produkt in den Daten
    var selectedProduct = null;
    for (var i = 0; i < this.products.length; i++) {
      if (String(this.products[i].id) === String(productId)) {
        selectedProduct = this.products[i];
        break;
      }
    }
    
    if (!selectedProduct) {
      console.error('Battery Assistant: Produkt nicht gefunden:', productId);
      return;
    }
    
    this.selectedProduct = selectedProduct;
    this.selection.productId = productId;
    this.selection.productTitle = selectedProduct.title;
    this.selection.image = selectedProduct.image;
    
    // Speichere ob dieses Produkt Varianten-Schritte ueberspringt
    this.skipVariantSteps = false;
    
    console.log('Battery Assistant: Produkt gewaehlt', this.selection, selectedProduct);
    
    var self = this;
    setTimeout(function() {
      if (hasVariants && selectedProduct.showVariants && selectedProduct.variants && selectedProduct.variants.length > 1) {
        // Produkt hat Varianten - zeige Größenauswahl
        self.skipVariantSteps = false;
        self.goToStep(2);
      } else if (selectedProduct.variants && selectedProduct.variants.length >= 1) {
        // Nur eine oder wenige Varianten ohne Größen-Auswahl - direkt zur Mengenauswahl
        var variant = selectedProduct.variants[0];
        self.selection.variantId = variant.id;
        self.selection.price = variant.price;
        // Filtere "Default Title" heraus
        var brandValue = variant.option2 || '';
        if (brandValue === 'Default Title') brandValue = '';
        self.selection.brand = brandValue || selectedProduct.title;
        var sizeValue = variant.option1 || '';
        if (sizeValue === 'Default Title') sizeValue = '';
        self.selection.sizeDisplay = sizeValue;
        self.skipVariantSteps = true;
        self.goToStep(4);
        self.loadQuantityOptions();
      } else {
        // Keine Varianten - direkt zur Mengenauswahl mit Basis-Produkt
        self.skipVariantSteps = true;
        self.goToStep(4);
        self.loadQuantityOptions();
      }
    }, 200);
  };
  
  // Hilfsfunktion: Bestimme den vorherigen Schritt basierend auf dem aktuellen Pfad
  BatteryAssistant.prototype.getPreviousStep = function(currentStep) {
    // Bei Multi-Produkt Modus mit uebersprungenen Varianten-Schritten
    if (this.useMultipleProducts && this.skipVariantSteps) {
      if (currentStep === 4 || currentStep === 5) {
        return 'product'; // Zurück zur Produktauswahl
      }
    }
    
    // Bei Multi-Produkt Modus normal
    if (this.useMultipleProducts) {
      if (currentStep === 2) {
        return 'product';
      }
    }
    
    // Standard-Navigation
    if (currentStep === 5) return 4;
    if (currentStep === 4) return 3;
    if (currentStep === 3) return 2;
    if (currentStep === 2) return this.data.showIntroStep ? 1 : 2;
    if (currentStep === 'product') return this.data.showIntroStep ? 1 : 'product';
    
    return 1;
  };
  
  // Hilfsfunktion: Aktuelles Produkt fuer Varianten-Suche
  BatteryAssistant.prototype.getCurrentProduct = function() {
    if (this.useMultipleProducts && this.selectedProduct) {
      return this.selectedProduct;
    }
    return this.data.product;
  };
  
  BatteryAssistant.prototype.selectSize = function(sizeCode, sizeDisplay, colorName, element) {
    var cards = this.container.querySelectorAll('.battery-assistant__card--size');
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.remove('is-selected');
      cards[i].setAttribute('aria-checked', 'false');
    }
    
    element.classList.add('is-selected');
    element.setAttribute('aria-checked', 'true');
    
    this.selection.sizeCode = sizeCode;
    this.selection.sizeDisplay = sizeDisplay;
    this.selection.sizeColor = colorName;
    
    console.log('Battery Assistant: Größe gewählt', this.selection);
    
    var self = this;
    setTimeout(function() {
      self.goToStep(3);
      self.loadBrands();
    }, 200);
  };
  
  BatteryAssistant.prototype.loadBrands = function() {
    var container = document.getElementById('BrandCards-' + this.sectionId);
    if (!container) return;
    
    // Verwende getCurrentProduct() fuer Multi-Produkt Unterstuetzung
    var currentProduct = this.getCurrentProduct();
    
    console.log('Battery Assistant: Lade Marken, Produkt-Daten:', currentProduct);
    
    if (!currentProduct || !currentProduct.variants) {
      container.innerHTML = '<p class="battery-assistant__error-text">Produkt nicht gefunden. Bitte konfigurieren Sie das Produkt-Handle in den Section-Einstellungen.<br><br>Aktueller Handle: ' + (this.data.productHandle || 'nicht gesetzt') + '</p>';
      return;
    }
    
    var selectedSizeCode = this.selection.sizeCode;
    var matchingVariants = [];
    
    console.log('Battery Assistant: Suche Varianten fuer Size-Code:', selectedSizeCode);
    console.log('Battery Assistant: Alle Varianten:', currentProduct.variants);
    
    for (var i = 0; i < currentProduct.variants.length; i++) {
      var variant = currentProduct.variants[i];
      console.log('Battery Assistant: Pruefe Variante', variant.title, 'option1:', variant.option1, 'available:', variant.available);
      if (variant.option1 === selectedSizeCode && variant.available) {
        matchingVariants.push(variant);
      }
    }
    
    console.log('Battery Assistant: Gefundene Varianten für Größe', selectedSizeCode, matchingVariants);
    
    if (matchingVariants.length === 0) {
      var allOption1Values = [];
      for (var i = 0; i < currentProduct.variants.length; i++) {
        var opt1 = currentProduct.variants[i].option1;
        if (allOption1Values.indexOf(opt1) === -1) {
          allOption1Values.push(opt1);
        }
      }
      container.innerHTML = '<p class="battery-assistant__error-text">Keine Varianten fuer diese Größe verfügbar.<br><br>Gesuchter Size-Code: <strong>' + selectedSizeCode + '</strong><br>Verfuegbare Option1-Werte: <strong>' + allOption1Values.join(', ') + '</strong></p>';
      return;
    }
    
    // Sort by price - CHEAPEST first, most expensive at bottom
    matchingVariants.sort(function(a, b) {
      return a.price - b.price;
    });
    
    // Badge texts for each position (cheap to expensive)
    var badgeTexts = ['Günstigste Option', 'Preis-Leistung', 'Sehr beliebt', 'Premium Qualität'];
    var badgeClasses = ['badge-cheapest', 'badge-value', 'badge-popular', 'badge-premium'];
    
    var html = '';
    var self = this;
    var totalVariants = matchingVariants.length;
    
    for (var i = 0; i < matchingVariants.length; i++) {
      var variant = matchingVariants[i];
      var brand = variant.option2 || 'Unbekannt';
      var price = this.formatMoney(variant.price);
      var pricePerBattery = this.formatMoney(Math.round(variant.price / 60));
      var isCheapest = i === 0;
      var imageUrl = variant.image || '';
      
      var badgeIndex = Math.min(i, badgeTexts.length - 1);
      var badgeText = badgeTexts[badgeIndex];
      var badgeClass = badgeClasses[badgeIndex];
      
      html += '<button type="button" class="battery-assistant__card battery-assistant__card--brand' +
              (isCheapest ? ' is-cheapest' : '') + '" ' +
              'data-action="select-brand" ' +
              'data-variant-id="' + variant.id + '" ' +
              'data-brand="' + this.escapeHtml(brand) + '" ' +
              'data-price="' + variant.price + '" ' +
              'data-image="' + this.escapeHtml(imageUrl) + '" ' +
              'role="radio" aria-checked="false">';
      
      html += '<span class="battery-assistant__card-badge ' + badgeClass + '">' + badgeText + '</span>';
      
      if (imageUrl) {
        html += '<div class="battery-assistant__card-image">' +
                '<img src="' + imageUrl + '" alt="' + this.escapeHtml(brand) + ' Größe ' + this.selection.sizeDisplay + '" loading="lazy">' +
                '</div>';
      }
      
      html += '<div class="battery-assistant__card-content">' +
              '<span class="battery-assistant__card-brand-name">' + this.escapeHtml(brand) + '</span>' +
              '<span class="battery-assistant__card-size-info">Größe ' + this.selection.sizeDisplay + ' - ' + this.selection.sizeColor + '</span>' +
              '</div>';
      
      html += '<div class="battery-assistant__card-pricing">' +
              '<span class="battery-assistant__card-price">' + price + '</span>' +
              '<span class="battery-assistant__card-price-info">' + this.data.texts.tax + '</span>' +
              '<span class="battery-assistant__card-price-per">' + pricePerBattery + ' ' + this.data.texts.perBattery + '</span>' +
              '</div>';
      
      html += '<span class="battery-assistant__card-check" aria-hidden="true">&#10003;</span>' +
              '</button>';
    }
    
    container.innerHTML = html;
  };
  
  BatteryAssistant.prototype.selectBrand = function(variantId, brand, price, image, element) {
    var cards = this.container.querySelectorAll('.battery-assistant__card--brand');
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.remove('is-selected');
      cards[i].setAttribute('aria-checked', 'false');
    }
    
    element.classList.add('is-selected');
    element.setAttribute('aria-checked', 'true');
    
    this.selection.variantId = parseInt(variantId, 10);
    this.selection.brand = brand;
    this.selection.price = parseInt(price, 10);
    this.selection.image = image;
    
    console.log('Battery Assistant: Marke gewaehlt', this.selection);
    
    var self = this;
    setTimeout(function() {
      self.goToStep(4);
      self.loadQuantityOptions();
    }, 200);
  };
  
  BatteryAssistant.prototype.loadQuantityOptions = function() {
    var container = document.getElementById('QuantityCards-' + this.sectionId);
    if (!container) return;
    
    var basePrice = this.selection.price;
    var html = '';
    var quantities = [1, 2, 3, 4, 5];
    
    for (var i = 0; i < quantities.length; i++) {
      var qty = quantities[i];
      var totalPrice = basePrice * qty;
      var totalBatteries = 60 * qty;
      var pricePerBattery = this.formatMoney(Math.round(totalPrice / totalBatteries));
      var isPopular = qty === 2;
      
      html += '<button type="button" class="battery-assistant__card battery-assistant__card--quantity' +
              (isPopular ? ' is-popular' : '') + '" ' +
              'data-action="select-quantity" ' +
              'data-quantity="' + qty + '" ' +
              'role="radio" aria-checked="false">';
      
      if (isPopular) {
        html += '<span class="battery-assistant__card-badge badge-popular">Beliebt</span>';
      }
      
      html += '<div class="battery-assistant__card-content">' +
              '<span class="battery-assistant__card-quantity-number">' + qty + '</span>' +
              '<span class="battery-assistant__card-quantity-label">' + (qty === 1 ? 'Packung' : 'Packungen') + '</span>' +
              '<span class="battery-assistant__card-quantity-batteries">' + totalBatteries + ' Batterien</span>' +
              '</div>';
      
      html += '<div class="battery-assistant__card-pricing">' +
              '<span class="battery-assistant__card-price">' + this.formatMoney(totalPrice) + '</span>' +
              '<span class="battery-assistant__card-price-info">' + this.data.texts.tax + '</span>' +
              '<span class="battery-assistant__card-price-per">' + pricePerBattery + ' ' + this.data.texts.perBattery + '</span>' +
              '</div>';
      
      html += '<span class="battery-assistant__card-check" aria-hidden="true">&#10003;</span>' +
              '</button>';
    }
    
    container.innerHTML = html;
  };
  
  BatteryAssistant.prototype.selectQuantity = function(quantity, element) {
    var cards = this.container.querySelectorAll('.battery-assistant__card--quantity');
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.remove('is-selected');
      cards[i].setAttribute('aria-checked', 'false');
    }
    
    element.classList.add('is-selected');
    element.setAttribute('aria-checked', 'true');
    
    this.selection.quantity = parseInt(quantity, 10);
    
    console.log('Battery Assistant: Menge gewaehlt', this.selection);
    
    var self = this;
    setTimeout(function() {
      self.goToStep(5);
      self.updateSummary();
    }, 200);
  };
  
  BatteryAssistant.prototype.updateSummary = function() {
    var brandEl = document.getElementById('SummaryBrand-' + this.sectionId);
    var sizeEl = document.getElementById('SummarySize-' + this.sectionId);
    var quantityEl = document.getElementById('SummaryQuantity-' + this.sectionId);
    var priceEl = document.getElementById('SummaryPrice-' + this.sectionId);
    var imageEl = document.getElementById('SummaryImage-' + this.sectionId);
    
    var totalPrice = this.selection.price * this.selection.quantity;
    var totalBatteries = 60 * this.selection.quantity;
    
    // Produktname oder Marke anzeigen
    var productName = this.selection.productTitle || this.selection.brand || 'Produkt';
    
    if (brandEl) {
      if (this.useMultipleProducts && this.selection.productTitle) {
        brandEl.textContent = this.selection.productTitle;
      } else {
        brandEl.textContent = this.selection.brand + ' Hoergeraetebatterien';
      }
    }
    
    if (sizeEl) {
      // Nur anzeigen wenn Größe vorhanden
      if (this.selection.sizeDisplay && this.selection.sizeColor) {
        sizeEl.textContent = 'Größe ' + this.selection.sizeDisplay + ' - ' + this.selection.sizeColor;
        sizeEl.style.display = '';
      } else if (this.selection.sizeDisplay) {
        sizeEl.textContent = this.selection.sizeDisplay;
        sizeEl.style.display = '';
      } else {
        sizeEl.style.display = 'none';
      }
    }
    
    if (quantityEl) {
      quantityEl.textContent = this.selection.quantity + ' ' + (this.selection.quantity === 1 ? 'Packung' : 'Packungen') + ' (' + totalBatteries + ' Batterien)';
    }
    
    if (priceEl) {
      priceEl.textContent = 'Gesamtpreis: ' + this.formatMoney(totalPrice);
    }
    
    if (imageEl && this.selection.image) {
      var altText = this.escapeHtml(productName);
      if (this.selection.sizeDisplay) {
        altText += ' Größe ' + this.selection.sizeDisplay;
      }
      imageEl.innerHTML = '<img src="' + this.selection.image + '" alt="' + altText + '" loading="lazy">';
    }
    
    var errorEl = document.getElementById('Error-' + this.sectionId);
    if (errorEl) {
      errorEl.hidden = true;
    }
  };
  
  BatteryAssistant.prototype.addToCart = function(button) {
    if (this.isProcessing) return;
    if (!this.selection.variantId) {
      this.showError('Bitte waehlen Sie zuerst eine Marke aus.');
      return;
    }
    if (!this.selection.quantity) {
      this.showError('Bitte waehlen Sie zuerst eine Menge aus.');
      return;
    }
    
    this.isProcessing = true;
    var originalText = button.textContent;
    button.textContent = this.data.texts.addingToCart;
    button.disabled = true;
    
    var self = this;
    
    // Tracking: Properties werden in der Bestellung angezeigt
    var properties = {
      'Bestellt ueber': 'Batterie-Assistent'
    };
    
    // Nur hinzufuegen wenn vorhanden
    if (this.selection.sizeDisplay && this.selection.sizeColor) {
      properties['Größe'] = this.selection.sizeDisplay + ' (' + this.selection.sizeColor + ')';
    } else if (this.selection.sizeDisplay) {
      properties['Größe'] = this.selection.sizeDisplay;
    }
    
    if (this.selection.brand) {
      properties['Marke'] = this.selection.brand;
    }
    
    if (this.selection.productTitle) {
      properties['Produkt'] = this.selection.productTitle;
    }
    
    var cartData = {
      id: this.selection.variantId,
      quantity: this.selection.quantity,
      properties: properties
    };
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(cartData)
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Netzwerkfehler');
      }
      return response.json();
    })
    .then(function(data) {
      console.log('Battery Assistant: Zum Warenkorb hinzugefuegt', data);
      
      if (self.data.directCheckout) {
        window.location.href = '/checkout';
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(function(error) {
      console.error('Battery Assistant: Fehler beim Hinzufuegen', error);
      self.showError(self.data.texts.error);
      button.textContent = originalText;
      button.disabled = false;
      self.isProcessing = false;
    });
  };
  
  BatteryAssistant.prototype.showError = function(message) {
    var errorEl = document.getElementById('Error-' + this.sectionId);
    var messageEl = document.getElementById('ErrorMessage-' + this.sectionId);
    
    if (errorEl && messageEl) {
      messageEl.textContent = message;
      errorEl.hidden = false;
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };
  
  BatteryAssistant.prototype.restart = function() {
    this.selection = {
      productId: null,
      productTitle: null,
      sizeCode: null,
      sizeDisplay: null,
      sizeColor: null,
      brand: null,
      variantId: null,
      price: null,
      image: null,
      quantity: 1
    };
    
    // Multi-Produkt Variablen Zurücksetzen
    this.selectedProduct = null;
    this.skipVariantSteps = false;
    
    var selectedCards = this.container.querySelectorAll('.battery-assistant__card.is-selected');
    for (var i = 0; i < selectedCards.length; i++) {
      selectedCards[i].classList.remove('is-selected');
      selectedCards[i].setAttribute('aria-checked', 'false');
    }
    
    var errorEl = document.getElementById('Error-' + this.sectionId);
    if (errorEl) {
      errorEl.hidden = true;
    }
    
    // Bestimme den ersten Schritt basierend auf Modus
    if (this.useMultipleProducts) {
      this.currentStep = this.data.showIntroStep ? 1 : 'product';
    } else {
      this.currentStep = this.data.showIntroStep ? 1 : 2;
    }
    this.goToStep(this.currentStep);
  };
  
  BatteryAssistant.prototype.formatMoney = function(cents) {
    var format = this.data.moneyFormat || '{{amount}} EUR';
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return format.replace(/\{\{\s*amount\s*\}\}/g, amount)
                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
                 .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount);
  };
  
  BatteryAssistant.prototype.escapeHtml = function(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };
  
  window.BatteryAssistant = BatteryAssistant;
  
  function initAllAssistants() {
    var containers = document.querySelectorAll('.battery-assistant[data-section-id]');
    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      var sectionId = container.dataset.sectionId;
      var instanceName = 'batteryAssistant_' + sectionId.replace(/-/g, '_');
      
      if (!window[instanceName]) {
        console.log('Battery Assistant: Initialisiere ' + instanceName);
        window[instanceName] = new BatteryAssistant(sectionId);
      }
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllAssistants);
  } else {
    initAllAssistants();
  }
  
  document.addEventListener('shopify:section:load', function(e) {
    setTimeout(initAllAssistants, 100);
  });
})();
